import { render, staticRenderFns } from "./router-view.vue?vue&type=template&id=531770cd&"
import script from "./router-view.vue?vue&type=script&lang=js&"
export * from "./router-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports